import moment from "moment"
import 'moment/locale/es'

moment.locale('es')